import { Component, Input, OnInit } from '@angular/core';
import { TaskDetailsObject } from 'src/app/models/tasks/tasks-details/task-details.model';

@Component({
  selector: 'app-tasks-details-scai',
  templateUrl: './tasks-details-scai.component.html',
  styleUrls: ['./tasks-details-scai.component.css']
})
export class TasksDetailsScaiComponent implements OnInit {

  scaiRequest: string;
  scaiResponse: string;

  @Input() taskDetails: TaskDetailsObject;

  constructor() {
  }

  ngOnInit() {
    if (this.taskDetails.getScai().getRequest()) {
      this.scaiRequest = JSON.stringify(JSON.parse(this.taskDetails.getScai().getRequest()), null, 2);
    }
    if (this.taskDetails.getScai().getResponse()) {
      this.scaiResponse = JSON.stringify(JSON.parse(this.taskDetails.getScai().getResponse()), null, 2);
    }
  }

}
